import { Component, ErrorHandler, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { KirjautunutTilintarkastajaService } from 'app/_angular/service/kirjautunut-tilintarkastaja.service'

@Component({
  standalone: false,
  templateUrl: './tilintarkastaja-tunnistautuminen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../login/login.component.css', './tilintarkastaja-tunnistautuminen.component.css'],
})
export class TilintarkastajaTunnistautuminenComponent implements OnInit {
  /** Taikalinkin avain (tunnistautumista ei suoritettu) */
  linkinAvain: string
  /** Virhe tunnistautumisessa */
  readonly tunnistautuminenVirhe = signal(false)

  /** Kirjaudutaan sisään custom tokenilla */
  readonly kirjaudutaanSisaan = signal(false)

  year = new Date().getFullYear()

  data: { lemonatorToken: string; lemonaidToken: string }

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _kirjautunutTilintarkastajaService: KirjautunutTilintarkastajaService,
  ) {
    this.data = this._router.currentNavigation()?.extras?.state as { lemonatorToken: string; lemonaidToken: string }
  }

  async ngOnInit() {
    // 1. Avattu taikalinkki
    this.linkinAvain = this._activatedRoute.snapshot.params?.linkinAvain

    if (!this.linkinAvain && !this.data) {
      this.tunnistautuminenVirhe.set(true)
    }

    // 2. Jos tokenit on saatu, kirjaudu sisään
    if (this.data?.lemonatorToken && this.data?.lemonaidToken) {
      this.kirjaudutaanSisaan.set(true)
      try {
        await this._kirjautunutTilintarkastajaService.kirjauduCustomTokenilla(this.data.lemonatorToken, this.data.lemonaidToken)
      } catch (error) {
        this._errorHandler.handleError(error)
        this.tunnistautuminenVirhe.set(true)
        this.kirjaudutaanSisaan.set(false)
      }
    }
  }
}
